export default __webpack_public_path__ + "static/media/arrows-descending.db11a4ed.svg";